import type {PromptOptionValue} from '@/components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types';
import {AiModel} from '@/components/ai-resdesign-prompt-box/ai-redesign-prompt-box.types';
import {AiImageModelOption, TextToImageGridErrorState} from './ai-image-panel.types';

export const getAiImageModelFromAiModel = (model: PromptOptionValue): AiImageModelOption => {
  switch (model) {
    case AiModel.Flux:
      return AiImageModelOption.DeepInfraFluxSchnell;
    case AiModel.Stability:
      return AiImageModelOption.StabilityAICore;
    case AiModel.StabilityUltra:
      return AiImageModelOption.StabilityAIUltra;
    case AiModel.NanoBanana:
      return AiImageModelOption.Gemini2_5;
    default:
      return AiImageModelOption.Auto;
  }
};

export const getAiModelFromAiImageModel = (model?: AiImageModelOption): PromptOptionValue => {
  switch (model) {
    case AiImageModelOption.DeepInfraFluxSchnell:
      return AiModel.Flux;
    case AiImageModelOption.StabilityAICore:
      return AiModel.Stability;
    case AiImageModelOption.StabilityAIUltra:
      return AiModel.StabilityUltra;
    case AiImageModelOption.Gemini2_5:
      return AiModel.NanoBanana;
    default:
      return AiModel.Auto;
  }
};

export const getErrorMessage = (errorState: TextToImageGridErrorState): string => {
  switch (errorState) {
    case TextToImageGridErrorState.FLAGGED:
      return window.i18next.t('pmwjs_search_prompt_violation_message');
    case TextToImageGridErrorState.VAGUE:
      return window.i18next.t('pmwjs_vague_prompt_error');
    case TextToImageGridErrorState.UNSUPPORTED_LANUAGE:
      return window.i18next.t('pmwjs_search_prompt_unsupported_language_message');
    case TextToImageGridErrorState.GENERIC:
      return window.i18next.t('pmwjs_unexpected_error_occurred');
    case TextToImageGridErrorState.NONE:
      return '';
  }
};
